import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

// Resolves the month's #1 inviter (leaderboard top[0]) and provides a matcher so their
// "Top Connector" crown can surface anywhere their name/avatar renders (profile, chat, public page).
// Auth-gated + fails gracefully: no token / endpoint down → nobody is flagged.
export function useTopConnector() {
  const hasToken = typeof window !== "undefined" && !!localStorage.getItem("bloq_token");
  const { data } = useQuery({
    queryKey: ["referral-top-connector", "month"],
    queryFn: () => api.referralLeaderboard("month"),
    enabled: hasToken,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  const top = data?.top?.[0] || null;
  const meIsTop = data?.me?.rank === 1;

  const isTopConnector = (u) => {
    if (!u) return false;
    if (u.is_top_connector === true) return true; // authoritative backend flag when present
    if (!top) return false;
    if (top.id && u.id && top.id === u.id) return true;
    const uh = (u.username || u.handle || "").toLowerCase();
    const th = (top.username || top.handle || "").toLowerCase();
    return !!uh && uh === th;
  };

  return { top, meIsTop, isTopConnector };
}
